import { Tooltip } from '@mui/material'
import { ButtonMui } from 'src/components/ButtonMui'
import styled from 'styled-components'

export const Container = styled.div`
    width: 30%;
    height: 100%;
`

export const CustomButton = styled(ButtonMui)`
    width: 6rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
export const CustomTooltip = styled(Tooltip)``
